import { render, staticRenderFns } from "./ValidationTabs.vue?vue&type=template&id=394d5bdb&scoped=true&"
import script from "./ValidationTabs.vue?vue&type=script&lang=js&"
export * from "./ValidationTabs.vue?vue&type=script&lang=js&"
import style0 from "./ValidationTabs.vue?vue&type=style&index=0&id=394d5bdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d5bdb",
  null
  
)

export default component.exports